<template>
  <div class="body-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body position-relative pb-1">
              <div class="row justify-content-between">
                <div class="col-md-4 col-12 mb-5 mb-lg-0">
                  <div>
                    <h4 class="card-title mb-1">
                      Resumo Geral
                    </h4>
                    <p class="mb-0 card-subtitle">
                      Resumo simplificado de toda plataforma
                    </p>
                  </div>
                  <div class="mt-4">
                    <div class="row align-items-center">
                      <div class="col-12">
                        <ul class="list-unstyled mb-4 mb-md-0">
                          <li class="d-flex align-items-center mb-9" v-if="individual.role_id > 3">
                            <div
                              class="bg-primary-subtle rounded-circle-shape px-3 py-2 me-3 rounded-5 d-flex align-items-center justify-content-center">
                              <iconify-icon icon="solar:cart-4-line-duotone" class="fs-7 text-primary"></iconify-icon>
                            </div>
                            <div>
                              <h6 class="mb-1 fs-4">{{ count_clients }} Clientes</h6>
                              <p class="mb-0 lh-1">Total</p>
                            </div>
                          </li>
                          <li class="d-flex align-items-center mb-9">
                            <div
                              class="bg-danger-subtle rounded-circle-shape px-3 py-2 me-3 rounded-5 d-flex align-items-center justify-content-center">
                              <iconify-icon icon="solar:checklist-minimalistic-line-duotone"
                                class="fs-7 text-danger"></iconify-icon>
                            </div>
                            <div>
                              <h6 class="mb-1 fs-4">{{ count_requests }} Solicitações</h6>
                              <p class="mb-0 lh-1">Mensal</p>
                            </div>
                          </li>
                          <li class="d-flex align-items-center" v-if="individual.role_id > 3">
                            <div
                              class="bg-success-subtle rounded-circle-shape px-3 py-2 me-3 rounded-5 d-flex align-items-center justify-content-center">
                              <iconify-icon icon="solar:banknote-line-duotone" class="fs-7 text-success"></iconify-icon>
                            </div>
                            <div>
                              <h6 class="mb-1 fs-4">{{ count_access }} Acessos</h6>
                              <p class="mb-0 lh-1">Mensal</p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-8 col-12">
                  <div class="d-flex align-items-baseline justify-content-between mb-2">
                    <div>
                      <h5 class="mb-1 card-title">Total Solicitações</h5>
                      <p class="mb-0 card-subtitle">Atualização geral</p>
                    </div>
                  </div>
                  <div class="me-n3">
                    <div id="netsells"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="card acedamic w-100">
            <div class="card-body p-4">
              <div class="d-flex mb-4 justify-content-between align-items-center">
                <div>
                  <h4 class="card-title">Últimas 10 atualizações</h4>
                  <p class="mb-0 card-subtitle">Será listado às 10 ultimas inserções</p>
                </div>
              </div>
              <ul class="nav nav-tabs nav-justified theme-tab table-responsive flex-nowrap" role="tablist">
                <li class="nav-item">
                  <a class="nav-link py-1 fs-3 me-1 active w-100" data-bs-toggle="tab" href="#one1" role="tab">
                    <span>Solicitações</span>
                  </a>
                </li>
                <li class="nav-item" v-if="individual.role_id > 3">
                  <a class="nav-link py-1 fs-3 me-1 w-100" data-bs-toggle="tab" href="#two2" role="tab">
                    <span>Clientes</span>
                  </a>
                </li>
              </ul>

              <div class="tab-content mt-2">
                <div class="tab-pane active" id="one1" role="tabpanel">
                  <div class="tab-content">
                    <div data-simplebar class="position-relative" style="height: 465px">
                      <div class="table-responsive overflow-x-auto products-tabel" data-simplebar>
                        <table class="table text-nowrap mb-0 align-middle">
                          <thead class="text-dark fs-4">
                            <tr>
                              <th v-if="individual.role_id > 3">
                                <h6 class="fs-4 fw-semibold mb-0">Cliente</h6>
                              </th>
                              <th>
                                <h6 class="fs-4 fw-semibold mb-0">Resp.</h6>
                              </th>
                              <th>
                                <h6 class="fs-4 fw-semibold mb-0">Data de Solicitação</h6>
                              </th>
                              <th>
                                <h6 class="fs-4 fw-semibold mb-0">Situação</h6>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in list_requests" :key="item.id">
                              <td v-if="individual.role_id > 3">
                                <div class="d-flex align-items-center">
                                  <div class="ms-3">
                                    <h6 class="fs-4 fw-semibold mb-0">{{ item.users.individual.name }}</h6>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">
                                  {{ item.collection_orders ? item.collection_orders.responsible : 'N/A' }}
                                </p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">{{ formatDate(item.created_at) }}</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">
                                  {{ item.status ? item.status.name : 'Sem status' }}
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane" id="two2" role="tabpanel" v-if="individual.role_id > 3">
                  <div class="tab-content">
                    <div data-simplebar class="position-relative" style="height: 465px">
                      <div class="table-responsive overflow-x-auto products-tabel" data-simplebar>
                        <table class="table text-nowrap mb-0 align-middle">
                          <thead class="text-dark fs-4">
                            <tr>
                              <th >
                                <h6 class="fs-4 fw-semibold mb-0">Nome</h6>
                              </th>
                              <th>
                                <h6 class="fs-4 fw-semibold mb-0">Telefone</h6>
                              </th>
                              <th>
                                <h6 class="fs-4 fw-semibold mb-0">Data de Criação</h6>
                              </th>
                              <th>
                                <h6 class="fs-4 fw-semibold mb-0">Status</h6>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in list_clients" :key="item.user_id">
                              <td>
                                <div class="d-flex align-items-center">
                                  <div class="ms-3">
                                    <h6 class="fs-4 fw-semibold mb-0">{{item.name}}</h6>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">{{item.phone}}</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">{{formatDate(item.created_at)}}</p>
                              </td>
                              <td>
                                <span class="badge bg-success-subtle text-success"
                                  v-if="item.is_active == 1">Ativo</span>
                                <span class="badge bg-danger-subtle text-danger" v-else>Inativo</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Cookies from 'js-cookie';

export default {
    data() {
      return {
        individual: null,
        count_clients: 0,
        count_requests: 0,
        count_access: 0,
        list_clients: [],
        list_requests: []
      }
    },
    methods: {
      load() {
        this.$http.get('/home', {
          headers: {
            'Authorization': 'Bearer ' + Cookies.get('_token')
          }
        }).then(response => {

          this.count_clients = response.data.count_clients;
          this.count_requests = response.data.count_requests;
          this.count_access = response.data.count_access;

          this.list_clients = response.data.list_clients;
          this.list_requests = response.data.list_requests;

        })
      },
      formatDate(inputDate){
          const date = new Date(inputDate);
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = date.getFullYear();
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0')
          const formattedDate = `${day}/${month}/${year} às ${hours}:${minutes}`;
          return formattedDate;
      },
    },
    created(){
      this.load();
      this.individual = JSON.parse(Cookies.get('individual'));
    }
}

</script>
